
import { reduce } from 'vessel/utils'

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    uniqueId() {
      return this.type.toUpperCase()
    },
    i18nKey() {
      const key = this.type.toLowerCase()
      return `product.compatibility.${key}`
    },
    compatibility() {
      return this.product.compatibility || []
    },
    isVisible() {
      return this.compatibility
        .some(({ taxonomy }) => taxonomy.uniqueId == this.uniqueId)
    },
    taxonomies() {
      const items = this.compatibility
        .filter(({ taxonomy }) => taxonomy.uniqueId == this.uniqueId)

      return reduce(items, (groups, taxon) => {
        const { name, parent } = taxon
        const group = groups[parent.id]

        if (!group) {
          groups[parent.id] = {
            id: parent.id,
            name: this.$t(this.i18nKey, { name: parent.name }),
            children: [name]
          }
        } else {
          group.children.push(name)
        }
      }, {})
    }
  }
}
